import {useContext, useEffect, useState} from "react";
import OwLabel from "../OwLabel/OwLabel";
import UiContext from "../../../contexts/UiContext";
import OwButton from "../OwButton/OwButton";

type Props = {
};

const OwPrintButton = (props: Props) => {
    const uiContext = useContext(UiContext);
    const [showPrint, setShowPrint] = useState(false);

    useEffect(() => {
        if (!uiContext.menuOpen && showPrint) {
            window.print();
            setShowPrint(false);
        }
    }, [uiContext.menuOpen]);

    const doPrint = () => {
        if (uiContext.menuOpen) {
            setShowPrint(true);
            uiContext.toggleMenu();
        } else {
            window.print();
        }
    };

    return (
            <OwButton id={"printButton"} title={"print"} leftIconClass={"fas fa-print"} className={"d-print-none btn-warning"} fn={doPrint}/>
    );
}

export default OwPrintButton;
